<template>
  <div class="app-container seo-api-log-page">
    <el-card shadow="never">
      <el-tabs v-model="activeTab" @tab-click="onTabChange">
        <el-tab-pane label="自动执行" name="auto"></el-tab-pane>
        <el-tab-pane label="Live手动诊断" name="live_manual"></el-tab-pane>
        <el-tab-pane label="连接测试" name="system_connection"></el-tab-pane>
        <el-tab-pane label="余额查询" name="system_wallet"></el-tab-pane>
      </el-tabs>

      <div class="-mb-16px">
        <el-form :model="params" size="small" label-width="70px" inline>
          <el-form-item v-if="showSiteFilter" label="站点">
            <el-select
              v-model="params.site_id"
              filterable
              placeholder="全部站点"
              class="w-220px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in siteOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="activeTab === 'auto'" label="调用方式">
            <el-select
              v-model="params.run_type"
              placeholder="全部方式"
              class="w-180px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="全部站点自动执行" value="all_sites"></el-option>
              <el-option label="单站点自动执行" value="single_site"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="activeTab === 'live_manual'" label="关键词">
            <el-input
              v-model="params.keyword"
              placeholder="请输入关键词"
              class="w-180px"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="activeTab === 'live_manual'" label="达标">
            <el-select
              v-model="params.qualified_status"
              placeholder="全部"
              class="w-120px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="达标" value="qualified"></el-option>
              <el-option label="未达标" value="unqualified"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="params.status"
              placeholder="全部状态"
              class="w-150px"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="自定义时间" label-width="90px">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="w-260px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="ml-6px">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card v-if="activeTab === 'auto'" class="mt-16px" shadow="never">
      <template #header>
        <span>自动执行 Run 总览</span>
      </template>
      <div class="data-table-scroll" style="--table-min-width: 2200px">
        <el-table :data="runPager.list" v-loading="runPager.loading">
          <el-table-column label="ID" width="70">
            <template v-slot="scope">
              {{ reverseRowSeq(runPager, scope.$index) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="run_no"
            label="Run 编号"
            width="170"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="执行类型" width="150">
            <template v-slot="scope">
              {{ runTypeText(scope.row.run_type) }}
            </template>
          </el-table-column>
          <el-table-column label="操作人" width="150" show-overflow-tooltip>
            <template v-slot="scope">
              {{ operatorText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="站点" min-width="150" show-overflow-tooltip>
            <template v-slot="scope">
              {{ scope.row.site_name || "全部站点" }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="110">
            <template v-slot="scope">
              <el-tag size="small" :type="statusTagType(scope.row.status)">
                {{ statusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="depth"
            label="depth"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="site_count"
            label="站点数"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="keyword_count"
            label="关键词"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="batch_count"
            label="批次"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="submitted_count"
            label="已提交"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="collected_count"
            label="已采集"
            width="90"
          ></el-table-column>
          <el-table-column label="等待采集" width="100">
            <template v-slot="scope">
              {{ waitingCount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="success_count"
            label="成功"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="failed_count"
            label="失败"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="not_found_count"
            label="未找到"
            width="90"
          ></el-table-column>
          <el-table-column label="cost" width="110">
            <template v-slot="scope">
              {{ formatCost(scope.row.total_cost) }}
            </template>
          </el-table-column>
          <el-table-column label="开始时间" width="160">
            <template v-slot="scope">
              {{ timeText(scope.row.started_at || scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column label="完成时间" width="160">
            <template v-slot="scope">
              {{ timeText(scope.row.finished_at) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="110">
            <template v-slot="scope">
              <el-button
                type="text"
                size="small"
                @click="openBatches(scope.row)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex justify-between mt-16px">
        <div></div>
        <pagination
          v-model="runPager"
          :pageSizes="[10, 20, 30]"
          @change="getRuns()"
        ></pagination>
      </div>
    </el-card>

    <el-card v-else class="mt-16px" shadow="never">
      <template #header>
        <span>{{ tabTitle }} API 调用日志</span>
      </template>
      <div class="data-table-scroll" style="--table-min-width: 1920px">
        <el-table :data="logsPager.list" v-loading="logsPager.loading">
          <el-table-column label="ID" width="70">
            <template v-slot="scope">
              {{ reverseRowSeq(logsPager, scope.$index) }}
            </template>
          </el-table-column>
          <el-table-column label="时间" width="150">
            <template v-slot="scope">
              {{ timeText(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column label="操作人" width="150" show-overflow-tooltip>
            <template v-slot="scope">
              {{ operatorText(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'live_manual'"
            label="站点"
            width="110"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              <span>{{ scope.row.site_name || "未关联站点" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'live_manual'"
            label="关键词"
            min-width="180"
            show-overflow-tooltip
          >
            <template v-slot="scope">
              {{ scope.row.keyword || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'live_manual'"
            label="depth"
            width="80"
          >
            <template v-slot="scope">
              {{ scope.row.depth || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="90">
            <template v-slot="scope">
              <el-tag size="small" :type="statusTagType(scope.row.status)">
                {{ statusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'live_manual'"
            label="cost"
            width="110"
          >
            <template v-slot="scope">
              {{ formatCost(scope.row.cost) }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'system_connection'"
            prop="request_summary"
            label="接口"
            min-width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            v-if="activeTab === 'system_wallet'"
            prop="response_summary"
            label="余额摘要"
            min-width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="provider_status_code"
            label="状态码"
            width="110"
          ></el-table-column>
          <el-table-column
            prop="provider_status_message"
            label="状态信息"
            min-width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="error_message"
            label="错误信息"
            min-width="180"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="耗时" width="90">
            <template v-slot="scope">
              {{ durationText(scope.row.duration_seconds) }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTab === 'live_manual'"
            label="完成时间"
            width="160"
          >
            <template v-slot="scope">
              {{ timeText(scope.row.finished_at) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex justify-between mt-16px">
        <div></div>
        <pagination
          v-model="logsPager"
          :pageSizes="[10, 20, 30]"
          @change="getLogs()"
        ></pagination>
      </div>
    </el-card>

    <el-drawer
      :visible.sync="batchDrawer.visible"
      :title="batchDrawer.title"
      size="82%"
      append-to-body
    >
      <div class="drawer-body">
        <div class="data-table-scroll" style="--table-min-width: 1850px">
          <el-table :data="batchPager.list" v-loading="batchPager.loading">
            <el-table-column
              prop="id"
              label="Batch ID"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="batch_no"
              label="批次号"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="batch_key"
              label="Batch Key"
              min-width="190"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="状态" width="100">
              <template v-slot="scope">
                <el-tag size="small" :type="statusTagType(scope.row.status)">
                  {{ statusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="task_count"
              label="任务数"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="submitted_count"
              label="已提交"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="collected_count"
              label="已采集"
              width="90"
            ></el-table-column>
            <el-table-column label="等待采集" width="100">
              <template v-slot="scope">
                {{ waitingCount(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="success_count"
              label="成功"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="failed_count"
              label="失败"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="not_found_count"
              label="未找到"
              width="90"
            ></el-table-column>
            <el-table-column label="cost" width="110">
              <template v-slot="scope">
                {{ formatCost(scope.row.total_cost) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="error_message"
              label="错误信息"
              min-width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="提交时间" width="160">
              <template v-slot="scope">
                {{ timeText(scope.row.submitted_at) }}
              </template>
            </el-table-column>
            <el-table-column label="采集时间" width="160">
              <template v-slot="scope">
                {{ timeText(scope.row.collected_at) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="110">
              <template v-slot="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="openTasks(scope.row)"
                >
                  关键词明细
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex justify-between mt-16px">
          <div></div>
          <pagination
            v-model="batchPager"
            :pageSizes="[10, 20, 50]"
            @change="getBatches()"
          ></pagination>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      :visible.sync="taskDrawer.visible"
      :title="taskDrawer.title"
      size="88%"
      append-to-body
    >
      <div class="drawer-body">
        <div class="data-table-scroll" style="--table-min-width: 1700px">
          <el-table :data="taskPager.list" v-loading="taskPager.loading">
            <el-table-column
              prop="id"
              label="Task ID"
              width="90"
            ></el-table-column>
            <el-table-column label="站点" width="130" show-overflow-tooltip>
              <template v-slot="scope">
                {{ scope.row.site_name || scope.row.site_id || "-" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="keyword"
              label="关键词"
              min-width="190"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="keyword_type"
              label="类型"
              width="90"
            ></el-table-column>
            <el-table-column label="状态" width="100">
              <template v-slot="scope">
                <el-tag size="small" :type="statusTagType(scope.row.status)">
                  {{ statusText(scope.row.status) }}
                </el-tag>
                <div
                  v-if="taskStatusHint(scope.row.status)"
                  class="status-hint"
                >
                  {{ taskStatusHint(scope.row.status) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="depth"
              label="depth"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="rank_group"
              label="排名"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="rank_absolute"
              label="绝对排名"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="matched_url"
              label="匹配URL"
              min-width="220"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="cost" width="110">
              <template v-slot="scope">
                {{ formatCost(scope.row.cost) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="provider_task_id"
              label="Provider Task ID"
              width="170"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="error_message"
              label="错误信息"
              min-width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="提交时间" width="160">
              <template v-slot="scope">
                {{ timeText(scope.row.submitted_at) }}
              </template>
            </el-table-column>
            <el-table-column label="完成时间" width="160">
              <template v-slot="scope">
                {{ timeText(scope.row.completed_at) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex justify-between mt-16px">
          <div></div>
          <pagination
            v-model="taskPager"
            :pageSizes="[10, 20, 50]"
            @change="getTasks()"
          ></pagination>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import {
  apiSeoApiLogLogs,
  apiSeoRankBatchList,
  apiSeoRankRunList,
  apiSeoRankRunTaskList,
  apiSeoSiteOptions,
} from "@/api/seo";
import { Pager } from "@/utils/pager";
import { formatDate } from "@/utils/util";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      activeTab: "auto",
      siteOptions: [],
      params: {
        site_id: "",
        run_type: "",
        status: "",
        keyword: "",
        qualified_status: "",
      },
      dateRange: [],
      logsPager: new Pager(),
      runPager: new Pager(),
      batchPager: new Pager(),
      taskPager: new Pager(),
      selectedRun: null,
      selectedBatch: null,
      batchDrawer: {
        visible: false,
        title: "批次列表",
      },
      taskDrawer: {
        visible: false,
        title: "关键词任务明细",
      },
    };
  },
  computed: {
    tabTitle() {
      return (
        {
          live_manual: "Live手动诊断",
          system_connection: "连接测试",
          system_wallet: "余额查询",
        }[this.activeTab] || "API"
      );
    },
    statusOptions() {
      if (this.activeTab === "auto") {
        return [
          { label: "待执行", value: "pending" },
          { label: "执行中", value: "running" },
          { label: "已完成", value: "completed" },
          { label: "部分失败", value: "partial_failed" },
          { label: "失败", value: "failed" },
        ];
      }
      return [
        { label: "成功", value: "success" },
        { label: "失败", value: "failed" },
        { label: "待处理", value: "pending" },
      ];
    },
    showSiteFilter() {
      return ["auto", "live_manual"].includes(this.activeTab);
    },
  },
  created() {
    this.getSiteOptions();
    this.getRuns();
  },
  methods: {
    formatDate,
    getSiteOptions() {
      apiSeoSiteOptions().then((resp) => {
        this.siteOptions = resp || [];
      });
    },
    getRuns(page) {
      page && (this.runPager.page = page);
      this.runPager.request({
        callback: apiSeoRankRunList,
        params: this.runQueryParams(),
      });
    },
    getBatches(page) {
      if (!this.selectedRun) {
        return;
      }
      page && (this.batchPager.page = page);
      this.batchPager.request({
        callback: apiSeoRankBatchList,
        params: {
          run_id: this.selectedRun.id,
        },
      });
    },
    getTasks(page) {
      if (!this.selectedBatch) {
        return;
      }
      page && (this.taskPager.page = page);
      this.taskPager.request({
        callback: apiSeoRankRunTaskList,
        params: {
          run_id: this.selectedBatch.run_id,
          batch_id: this.selectedBatch.id,
        },
      });
    },
    getLogs(page) {
      page && (this.logsPager.page = page);
      this.logsPager.request({
        callback: apiSeoApiLogLogs,
        params: this.logQueryParams(),
      });
    },
    onTabChange() {
      this.params.run_type = "";
      this.params.status = "";
      this.params.keyword = "";
      this.params.qualified_status = "";
      if (!this.showSiteFilter) {
        this.params.site_id = "";
      }
      this.dateRange = [];
      if (this.activeTab === "auto") {
        this.getRuns(1);
      } else {
        this.getLogs(1);
      }
    },
    onSearch() {
      if (this.activeTab === "auto") {
        this.getRuns(1);
      } else {
        this.getLogs(1);
      }
    },
    onReset() {
      this.params.site_id = "";
      this.params.run_type = "";
      this.params.status = "";
      this.params.keyword = "";
      this.params.qualified_status = "";
      this.dateRange = [];
      this.onSearch();
    },
    openBatches(row) {
      this.selectedRun = row;
      this.batchDrawer.title = `Run ${row.run_no || row.id} / 批次列表`;
      this.batchDrawer.visible = true;
      this.batchPager.page = 1;
      this.getBatches();
    },
    openTasks(row) {
      this.selectedBatch = row;
      this.taskDrawer.title = `Batch ${
        row.batch_no || row.id
      } / 关键词任务明细`;
      this.taskDrawer.visible = true;
      this.taskPager.page = 1;
      this.getTasks();
    },
    runQueryParams() {
      const params = {
        site_id: this.params.site_id,
        run_type: this.params.run_type,
        status: this.params.status,
      };
      this.appendDateParams(params);
      return params;
    },
    logQueryParams() {
      const params = {
        site_id: this.params.site_id,
        call_mode: this.activeTab,
        status: this.params.status,
      };
      if (this.activeTab === "live_manual") {
        params.keyword = this.params.keyword;
        params.qualified_status = this.params.qualified_status;
      }
      this.appendDateParams(params);
      return params;
    },
    appendDateParams(params) {
      if (this.dateRange && this.dateRange.length === 2) {
        params.start_time = this.toUnix(this.dateRange[0]);
        params.end_time = this.toUnix(this.dateRange[1]) + 86399;
      }
    },
    toUnix(value) {
      return Math.floor(new Date(value).getTime() / 1000);
    },
    timeText(value) {
      return value ? formatDate(value, "yyyy-mm-dd hh:MM:ss") : "-";
    },
    formatCost(value) {
      return Number(value || 0).toFixed(6);
    },
    reverseRowSeq(pager, index) {
      const offset = (Number(pager.page || 1) - 1) * Number(pager.size || 10);
      return Math.max(1, Number(pager.count || 0) - offset - index);
    },
    durationText(value) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      return `${value}s`;
    },
    operatorText(row) {
      if (row.operator_name) {
        return row.operator_name;
      }
      if (row.operator_type === "admin") {
        return (
          row.admin_account || (row.admin_id ? `管理员ID ${row.admin_id}` : "-")
        );
      }
      if (row.operator_type === "system") {
        return row.admin_account
          ? `系统任务 / 发起：${row.admin_account}`
          : "系统任务";
      }
      return row.admin_id || row.admin_account
        ? row.admin_account || row.admin_id
        : "历史记录";
    },
    runTypeText(runType) {
      return (
        {
          all_sites: "全部站点自动执行",
          single_site: "单站点自动执行",
        }[runType] ||
        runType ||
        "-"
      );
    },
    callModeText(callMode) {
      return (
        {
          live_manual: "Live手动诊断",
          standard_all: "Standard全部站点异步",
          standard_site: "Standard单站点异步",
          standard_collect: "Standard结果采集",
          system_connection: "连接测试",
          system_wallet: "钱包余额查询",
          expand_keywords: "关键词拓展",
        }[callMode] ||
        callMode ||
        "-"
      );
    },
    statusText(status) {
      return (
        {
          success: "成功",
          failed: "失败",
          pending: "待提交",
          submitted: "等待采集",
          skipped: "未就绪",
          timeout: "超时",
          collecting: "采集中",
          running: "执行中",
          completed: "已完成",
          partial_failed: "部分失败",
        }[status] ||
        status ||
        "-"
      );
    },
    statusTagType(status) {
      return (
        {
          success: "success",
          completed: "success",
          failed: "danger",
          timeout: "danger",
          partial_failed: "warning",
          running: "",
          submitted: "",
          skipped: "info",
          collecting: "",
          pending: "info",
        }[status] || "info"
      );
    },
    waitingCount(row) {
      const total = Number(row.keyword_count || row.task_count || 0);
      const done =
        Number(row.collected_count || 0) + Number(row.failed_count || 0);
      return Math.max(0, total - done);
    },
    taskStatusHint(status) {
      return (
        {
          submitted: "等待 DataForSEO 返回结果",
          pending: "等待提交到 DataForSEO",
          timeout: "超过 60 分钟未完成",
        }[status] || ""
      );
    },
  },
};
</script>

<style scoped>
.drawer-body {
  padding: 0 20px 20px;
}
.status-hint {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 16px;
  white-space: normal;
}
</style>
